
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rsldashboard/bookinglist",
      function () {
        return require("private-next-pages/rsldashboard/bookinglist/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rsldashboard/bookinglist"])
      });
    }
  